// src/pages/AccountDetailPage.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import MainLayout from "../layout/MainLayout";
import { API_BASE } from "../config/orbisConfig";
//import { useNavigate } from "react-router-dom";


function AccountDetailLeadWebStyle() {
    return (
        <style>{`
            .account-detail-pro{color:#f5fbff}
            .account-detail-pro select option{background:#061a2f;color:white}
            .account-detail-pro .crm-hero{background:linear-gradient(135deg,#03111f 0%,#031a2f 55%,#04223d 100%);border:1px solid rgba(11,93,140,.8);box-shadow:0 20px 45px rgba(0,0,0,.28)}
            .account-detail-pro .crm-card{border:1px solid rgba(11,93,140,.82);background:#04192b;box-shadow:0 12px 30px rgba(0,0,0,.24)}
            .account-detail-pro .crm-card-head{background:#031425;border-bottom:1px solid #0b4d78}
            .account-detail-pro .crm-actions-bar{background:#031425;border:1px solid #0b4d78;border-radius:22px}
            .account-detail-pro .crm-btn{border:1px solid #24537a;background:#0b2740;color:#f5fbff;border-radius:999px;padding:10px 14px;font-size:12px;font-weight:700}
            .account-detail-pro .crm-btn:hover{background:#10324f;border-color:#d4af37}
            .account-detail-pro .crm-btn-primary{background:#d4af37;color:#081a2b;border-color:#d4af37}
            .account-detail-pro .crm-btn-primary:hover{background:#e8c457}
            .account-detail-pro .crm-input{width:100%;border:1px solid #0b5f91;border-radius:.85rem;padding:.65rem .75rem;font-size:12px;outline:none;background:#0b2740;color:#fff}
            .account-detail-pro .crm-input::placeholder{color:#7ea8c7}
            .account-detail-pro .crm-input:focus{border-color:#d4af37;box-shadow:0 0 0 2px rgba(212,175,55,.18)}
            .account-detail-pro .crm-label{display:block;font-size:11px;color:#8fb9da;margin-bottom:6px;font-weight:700;text-transform:uppercase;letter-spacing:.14em}
            .account-detail-pro table{border-collapse:separate;border-spacing:0;background:#061a2f}
            .account-detail-pro table tbody tr{transition:background .18s ease, box-shadow .18s ease;background:#08233d!important}
            .account-detail-pro table tbody tr:nth-child(even){background:#092a49!important}
            .account-detail-pro table tbody tr:hover{background:rgba(56,189,248,.075)!important;box-shadow:inset 3px 0 0 #d4af37}
            .account-detail-pro table tbody td{border-top:1px solid #24587c;background:transparent!important;color:#f5fbff}
            .account-detail-pro table thead th{position:sticky;top:0;z-index:10;background:#061a2f!important;color:#8fb9da;border-bottom:1px solid #24587c;text-transform:uppercase;letter-spacing:.13em}
            .account-detail-pro .crm-scroll{overflow:auto;max-height:70vh}
            .account-detail-pro .crm-scroll-top{overflow-x:auto;overflow-y:hidden;height:14px;border:1px solid #24587c;border-radius:999px;background:#061a2f;margin:0 12px 8px 12px}
            .account-detail-pro .crm-scroll-spacer{height:1px;min-width:1100px}
            .account-detail-pro .crm-scroll::-webkit-scrollbar,.account-detail-pro .crm-scroll-top::-webkit-scrollbar{height:10px;width:10px}
            .account-detail-pro .crm-scroll::-webkit-scrollbar-track,.account-detail-pro .crm-scroll-top::-webkit-scrollbar-track{background:#061a2f;border-radius:999px}
            .account-detail-pro .crm-scroll::-webkit-scrollbar-thumb,.account-detail-pro .crm-scroll-top::-webkit-scrollbar-thumb{background:#2b638e;border-radius:999px}
            .account-detail-pro .crm-scroll::-webkit-scrollbar-thumb:hover,.account-detail-pro .crm-scroll-top::-webkit-scrollbar-thumb:hover{background:#d4af37}
            .account-detail-pro .grid-row-main{font-weight:700;color:#fff!important}
            .account-detail-pro .grid-row-sub{color:#9fc4df!important;font-size:12px}
            .account-detail-pro .crm-badge{display:inline-flex;align-items:center;border-radius:999px;border:1px solid #24537a;background:#0f2d48;color:#d9e8f5;padding:4px 9px;font-size:10px;font-weight:700}
            .account-detail-pro .crm-modal-panel{background:#04192b;border:1px solid #0b5f91;color:#fff;box-shadow:0 20px 60px rgba(0,0,0,.35)}
            .account-detail-pro .crm-modal-head{background:#031425;border-bottom:1px solid #0b4d78}
        `}</style>
    );
}

const AccountDetailPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const accountId = Number(id);

    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");
    const [account, setAccount] = useState(null);
    const [opportunities, setOpportunities] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [form, setForm] = useState({
        name: "",
        alias: "",
        sector: "",
        city: "",
        state: "",
        country: "",
        website: "",
        phone: "",
        email: "",
        notes: "",
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                setError("");

                const [accRes, oppRes] = await Promise.all([
                    fetch("${API_BASE}/accounts_list.php"),
                    fetch("${API_BASE}/opportunities_list.php"),
                ]);

                const accData = await accRes.json().catch(() => []);
                const oppData = await oppRes.json().catch(() => []);

                const accList = Array.isArray(accData) ? accData : [];
                const oppList = Array.isArray(oppData) ? oppData : [];

                const found = accList.find((a) => Number(a.id) === accountId);
                if (!found) {
                    setError("No se encontró la cuenta solicitada.");
                    setAccount(null);
                } else {
                    setAccount(found);
                    setForm({
                        name: found.name || "",
                        alias: found.alias || "",
                        sector: found.sector || "",
                        city: found.city || "",
                        state: found.state || "",
                        country: found.country || "",
                        website: found.website || "",
                        phone: found.phone || "",
                        email: found.email || "",
                        notes: found.notes || "",
                    });
                }

                const filteredOpps = oppList.filter(
                    (o) => Number(o.account_id) === accountId
                );
                setOpportunities(filteredOpps);
            } catch (err) {
                console.error(err);
                setError("Error al cargar la información de la cuenta.");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [accountId]);

    const formatDate = (dtString) => {
        if (!dtString) return "-";
        const [y, m, d] = dtString.split(" ")[0].split("-");
        if (!y || !m || !d) return dtString;
        return `${d}/${m}/${y}`;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSave = async (e) => {
        e.preventDefault();
        if (!account) return;

        try {
            setSaving(true);
            setError("");

            const payload = {
                id: accountId,
                ...form,
            };

            const res = await fetch("${API_BASE}/account_update.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            const data = await res.json().catch(() => ({}));

            if (!res.ok || data.success === false) {
                throw new Error(data.error || "No se pudo actualizar la cuenta.");
            }

            // Actualizamos estado local
            const updated = { ...account, ...form };
            setAccount(updated);
            setIsEditing(false);
            alert("Cuenta actualizada correctamente.");
        } catch (err) {
            console.error(err);
            setError(err.message || "Error al guardar cambios.");
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return (
            <MainLayout>
                <AccountDetailLeadWebStyle />
                <div className="p-4 text-xs text-[#9fc4df]">Cargando cuenta…</div>
            </MainLayout>
        );
    }

    if (!account) {
        return (
            <MainLayout>
                <div className="p-4">
                    {error && (
                        <div className="mb-3 text-xs text-[#fca5a5] bg-[#2b1117] border border-[#ef4444]/40 rounded-lg px-3 py-2">
                            {error}
                        </div>
                    )}
                    <button
                        onClick={() => navigate("/accounts")}
                        className="crm-btn"
                    >
                        ← Volver a cuentas
                    </button>
                </div>
            </MainLayout>
        );
    }

    return (
        <MainLayout>
            <div className="account-detail-pro min-h-screen bg-[#041426] px-3 py-6 md:px-6 md:py-8"><div className="mx-auto max-w-[1500px] space-y-6">
                {/* Encabezado */}
                <div className="crm-hero rounded-[28px] px-6 py-6 md:px-7 md:py-7 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                    <div>
                        <button
                            onClick={() => navigate("/accounts")}
                            className="text-[11px] text-[#8fd8ff] hover:underline mb-1"
                        >
                            ← Volver a cuentas
                        </button>
                        <h2 className="text-3xl md:text-4xl font-black tracking-tight text-white">
                            {account.name}
                        </h2>
                        <p className="text-xs md:text-sm text-[#9fc4df]">
                            Detalle de cuenta y oportunidades asociadas.
                        </p>
                    </div>
                    <div className="flex gap-2 text-xs">
                        <button
                            onClick={() => setIsEditing((prev) => !prev)}
                            className="crm-btn"
                        >
                            {isEditing ? "Cancelar edición" : "Editar cuenta"}
                        </button>
                    </div>
                </div>

                {error && (
                    <div className="mb-2 text-xs text-[#fca5a5] bg-[#2b1117] border border-[#ef4444]/40 rounded-lg px-3 py-2">
                        {error}
                    </div>
                )}

                {/* Panel de datos + formulario */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                    {/* Datos principales */}
                    <div className="crm-card rounded-[24px] p-5 space-y-3 text-xs">
                        <h3 className="text-[11px] font-semibold tracking-[0.22em] uppercase text-[#d4af37] mb-3">
                            Información de la cuenta
                        </h3>
                        <p>
                            <span className="font-semibold text-[#d7e8f6]">Nombre: </span>
                            {account.name || "-"}
                        </p>
                        {account.alias && (
                            <p>
                                <span className="font-semibold text-[#d7e8f6]">Alias: </span>
                                {account.alias}
                            </p>
                        )}
                        {account.sector && (
                            <p>
                                <span className="font-semibold text-[#d7e8f6]">Sector: </span>
                                {account.sector}
                            </p>
                        )}
                        {(account.city || account.state || account.country) && (
                            <p>
                                <span className="font-semibold text-[#d7e8f6]">
                                    Ubicación:{" "}
                                </span>
                                {[account.city, account.state, account.country]
                                    .filter(Boolean)
                                    .join(", ") || "-"}
                            </p>
                        )}
                        {account.website && (
                            <p>
                                <span className="font-semibold text-[#d7e8f6]">Sitio web: </span>
                                <a
                                    href={account.website}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="text-[#8fd8ff] hover:underline"
                                >
                                    {account.website}
                                </a>
                            </p>
                        )}
                        {account.phone && (
                            <p>
                                <span className="font-semibold text-[#d7e8f6]">Teléfono: </span>
                                {account.phone}
                            </p>
                        )}
                        {account.email && (
                            <p>
                                <span className="font-semibold text-[#d7e8f6]">Correo: </span>
                                {account.email}
                            </p>
                        )}
                        {account.created_at && (
                            <p>
                                <span className="font-semibold text-[#d7e8f6]">
                                    Creada el:{" "}
                                </span>
                                {formatDate(account.created_at)}
                            </p>
                        )}
                        {account.notes && (
                            <p className="mt-2">
                                <span className="font-semibold text-[#d7e8f6]">Notas: </span>
                                {account.notes}
                            </p>
                        )}
                    </div>

                    {/* Formulario de edición */}
                    {isEditing && (
                        <form
                            onSubmit={handleSave}
                            className="crm-card rounded-[24px] p-5 space-y-4 text-xs"
                        >
                            <h3 className="text-[11px] font-semibold tracking-[0.22em] uppercase text-[#d4af37] mb-3">
                                Editar cuenta
                            </h3>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                <div>
                                    <label className="crm-label">
                                        Nombre
                                    </label>
                                    <input
                                        type="text"
                                        name="name"
                                        value={form.name}
                                        onChange={handleChange}
                                        className="crm-input"
                                        required
                                    />
                                </div>

                                <div>
                                    <label className="crm-label">
                                        Alias
                                    </label>
                                    <input
                                        type="text"
                                        name="alias"
                                        value={form.alias}
                                        onChange={handleChange}
                                        className="crm-input"
                                    />
                                </div>

                                <div>
                                    <label className="crm-label">
                                        Sector
                                    </label>
                                    <input
                                        type="text"
                                        name="sector"
                                        value={form.sector}
                                        onChange={handleChange}
                                        className="crm-input"
                                    />
                                </div>

                                <div>
                                    <label className="crm-label">
                                        Sitio web
                                    </label>
                                    <input
                                        type="text"
                                        name="website"
                                        value={form.website}
                                        onChange={handleChange}
                                        className="crm-input"
                                    />
                                </div>

                                <div>
                                    <label className="crm-label">
                                        Ciudad
                                    </label>
                                    <input
                                        type="text"
                                        name="city"
                                        value={form.city}
                                        onChange={handleChange}
                                        className="crm-input"
                                    />
                                </div>

                                <div>
                                    <label className="crm-label">
                                        Estado
                                    </label>
                                    <input
                                        type="text"
                                        name="state"
                                        value={form.state}
                                        onChange={handleChange}
                                        className="crm-input"
                                    />
                                </div>

                                <div>
                                    <label className="crm-label">
                                        País
                                    </label>
                                    <input
                                        type="text"
                                        name="country"
                                        value={form.country}
                                        onChange={handleChange}
                                        className="crm-input"
                                    />
                                </div>

                                <div>
                                    <label className="crm-label">
                                        Teléfono
                                    </label>
                                    <input
                                        type="text"
                                        name="phone"
                                        value={form.phone}
                                        onChange={handleChange}
                                        className="crm-input"
                                    />
                                </div>

                                <div>
                                    <label className="crm-label">
                                        Correo
                                    </label>
                                    <input
                                        type="email"
                                        name="email"
                                        value={form.email}
                                        onChange={handleChange}
                                        className="crm-input"
                                    />
                                </div>
                            </div>

                            <div>
                                <label className="crm-label">
                                    Notas
                                </label>
                                <textarea
                                    name="notes"
                                    value={form.notes}
                                    onChange={handleChange}
                                    rows={3}
                                    className="crm-input resize-none"
                                />
                            </div>

                            <div className="flex justify-end gap-2 pt-2">
                                <button
                                    type="button"
                                    onClick={() => setIsEditing(false)}
                                    className="px-3 py-1.5 rounded-lg border border-[#0b4d78] text-[#d9e8f5] text-xs hover:bg-[#10324f]"
                                >
                                    Cancelar
                                </button>
                                <button
                                    type="submit"
                                    disabled={saving}
                                    className="crm-btn crm-btn-primary disabled:opacity-60"
                                >
                                    {saving ? "Guardando..." : "Guardar cambios"}
                                </button>
                            </div>
                        </form>
                    )}
                </div>

                {/* Oportunidades de la cuenta */}
                <div className="bg-[#04192b] border border-[#0b4d78] rounded-xl shadow-sm overflow-hidden">
                    <div className="px-4 py-3 border-b border-[#0b4d78] flex items-center justify-between">
                        <div>
                            <h3 className="text-xs font-semibold text-white">
                                Oportunidades vinculadas
                            </h3>
                            <p className="text-[11px] text-[#9fc4df]">
                                Todas las oportunidades asociadas a esta cuenta.
                            </p>
                        </div>
                    </div>
                    <div className="max-h-96 overflow-y-auto">
                        <table className="min-w-full text-xs">
                            <thead className="bg-[#08233d]">
                                <tr className="text-left text-[11px] font-semibold text-[#d7e8f6]">
                                    <th className="px-3 py-2">Oportunidad</th>
                                    <th className="px-3 py-2 hidden sm:table-cell">Etapa</th>
                                    <th className="px-3 py-2 hidden md:table-cell">
                                        Cierre objetivo
                                    </th>
                                    <th className="px-3 py-2">Valor</th>
                                </tr>
                            </thead>
                            <tbody>
                                {opportunities.length === 0 && (
                                    <tr>
                                        <td
                                            colSpan={4}
                                            className="px-3 py-4 text-center text-[#8fb9da]"
                                        >
                                            Esta cuenta aún no tiene oportunidades registradas.
                                        </td>
                                    </tr>
                                )}
                                {opportunities.map((o) => {
                                    const stage =
                                        (o.stage || o.status || "").toString() || "-";
                                    const value =
                                        o.estimated_value ?? o.amount ?? o.value ?? 0;
                                    const currency = o.currency || "MXN";
                                    return (
                                        <tr
                                            key={o.id}
                                            className="border-t border-[#0b4d78] hover:bg-[#10324f]/60"
                                        >
                                            <td className="px-3 py-2 text-[11px] text-white">
                                                <div>{o.name}</div>
                                            </td>
                                            <td className="px-3 py-2 hidden sm:table-cell text-[11px] text-[#d7e8f6]">
                                                {stage}
                                            </td>
                                            <td className="px-3 py-2 hidden md:table-cell text-[11px] text-[#d7e8f6]">
                                                {o.close_date ? formatDate(o.close_date) : "-"}
                                            </td>
                                            <td className="px-3 py-2 text-[11px] text-[#d9e8f5]">
                                                {value
                                                    ? `${currency} ${Number(value).toLocaleString()}`
                                                    : "-"}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            </div>
        </MainLayout>
    );
};

export default AccountDetailPage;
